<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="白名单名称" prop="course_whitelist_name">
        <el-input v-model="post.course_whitelist_name" maxlength="16" show-word-limit clearable placeholder="请输入 1 ~ 16 位字符的白名单名称"/>
      </el-form-item>
      <el-form-item label="白名单学员" prop="student_ids">
        <v-select-student
          class="w100"
          v-model="post.student_ids"
          :multiple="true"
          :clearable="true"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.courseWhitelistList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/course-whitelist';

export default {
  name: RouteConfig.courseWhitelistList.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    post: {
      course_whitelist_name: '',
      student_ids: [],
    },
    rules: {
      course_whitelist_name: [{ required: true, message: '请输入白名单名称', trigger: 'change' }],
      student_ids: [{ required: true, message: '请选择白名单学员', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const post = { ...this.post };
        this.isSaving = true;
        const { isError } = await store(post);
        this.isSaving = false;
        if (!isError) RouteConfig.courseWhitelistList.push();
      });
    },
  },
};
</script>
